var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "20px",
    viewBox: "0 0 12 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "full",
    transform: "translate(-6.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65,2.25 L15.35,2.25 L15.35,4.5 L15.35,4.75 L15.6,4.75 L17.75,4.75 L17.75,21.75 L6.25,21.75 L6.25,4.75 L8.4,4.75 L8.65,4.75 L8.65,4.5 L8.65,2.25 Z",
    id: "Combined-Shape",
    stroke: "#657786",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    fill: "#4CAF50",
    x: 7,
    y: 6,
    width: 10,
    height: 15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/full.7c778c945a6f34b385b0f655674eaf31.svg";
export { ForwardRef as ReactComponent };